module.exports = __webpack_public_path__ + "static/media/G0142657_China-25.fbd70e79.png";